import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { SeFeTab } from 'se-fe-tabs'

@Component({
  selector: 'app-open-registration',
  templateUrl: './open-registration.component.html',
  standalone: false,
})
export class OpenRegistrationComponent {
  public tabs: SeFeTab[]

  constructor(private translate: TranslateService) {
    this.tabs = [
      { routerLink: '/user/open-registration/open', text: this.translate.instant('REGISTRATIONS.open_registrations') },
      { routerLink: '/user/open-registration/completed', text: this.translate.instant('REGISTRATIONS.completed_registrations') },
    ]
  }
}

@Component({
  selector: 'app-registration-tab-placeholder',
  template: '',
  standalone: false,
})
export class RegistrationTabPlaceholderComponent {}
